export const slidesData = [
  {
    id: "1",
    src: "/assets/Carousel-1.png",
    alt: "Carousel1",
  },
  {
    id: "2",
    src: "/assets/Carousel-2.png",
    alt: "Carousel2",
  },
  {
    id: "3",
    src: "/assets/Carousel-3.png",
    alt: "Carousel3",
  },
];

export const avatarList = [
  {
    src: "/assets/avatar-man-1.png",
    alt: "avatar-man-1",
  },
  {
    src: "/assets/avatar-man-2.png",
    alt: "avatar-man-2",
  },
  {
    src: "/assets/avatar-man-3.png",
    alt: "avatar-man-3",
  },
  {
    src: "/assets/avatar-man-4.png",
    alt: "avatar-man-4",
  },
  {
    src: "/assets/avatar-man-5.png",
    alt: "avatar-man-5",
  },
  {
    src: "/assets/avatar-man-6.png",
    alt: "avatar-man-6",
  },
  {
    src: "/assets/avatar-man-7.png",
    alt: "avatar-man-7",
  },
  {
    src: "/assets/avatar-man-8.png",
    alt: "avatar-man-8",
  },
  {
    src: "/assets/avatar-man-9.png",
    alt: "avatar-man-9",
  },
  {
    src: "/assets/avatar-man-10.png",
    alt: "avatar-man-10",
  },

  {
    src: "/assets/avatar-woman-1.png",
    alt: "avatar-woman-1",
  },
  {
    src: "/assets/avatar-woman-2.png",
    alt: "avatar-woman-2",
  },
  {
    src: "/assets/avatar-woman-3.png",
    alt: "avatar-woman-3",
  },
  {
    src: "/assets/avatar-woman-4.png",
    alt: "avatar-woman-4",
  },
  {
    src: "/assets/avatar-woman-5.png",
    alt: "avatar-woman-5",
  },
  {
    src: "/assets/avatar-woman-6.png",
    alt: "avatar-woman-6",
  },
  {
    src: "/assets/avatar-woman-7.png",
    alt: "avatar-woman-7",
  },
  {
    src: "/assets/avatar-woman-8.png",
    alt: "avatar-woman-8",
  },
  {
    src: "/assets/avatar-woman-9.png",
    alt: "avatar-woman-9",
  },
  {
    src: "/assets/avatar-woman-10.png",
    alt: "avatar-woman-10",
  },
];

export const SERVICE_NAME = "rhea-service";
